/**
 * Builds API URL paths for deck and slide endpoints
 */
export function buildApiUrl(
  userSlugOrId: string,
  deckId: string,
  path: string
): string {
  if (path.startsWith('/slides/')) {
    return `/api/v1/${userSlugOrId}/${deckId}${path}`;
  }
  return `/api/v1/${userSlugOrId}${path}`;
}

/**
 * Gets auth headers with bearer token from localStorage
 */
export function getAuthHeaders(): HeadersInit {
  const token = localStorage.getItem('token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
}

/**
 * Gets auth headers without content-type (for form uploads)
 */
export function getAuthHeadersWithoutContentType(): HeadersInit {
  const token = localStorage.getItem('token');
  return {
    'Authorization': `Bearer ${token}`,
  };
}
